import * as React from 'react';
import { connect } from 'react-redux';
import * as mobileUtils from 'login-utils/mobileUtils';
import { updateViewType } from 'login-actions/globalActions';
import { bindActionCreators } from 'redux';
import * as _ from 'lodash';

interface MobileWatcherProps {
  updateViewType(viewType: string): any;
  viewType: string;
}

class MobileWatcher extends React.Component<MobileWatcherProps, {}> {
  private eventListenerReference;

  componentDidMount() {
    const self = this;

    // We're storing a reference to this so we can neatly remove it later.
    this.eventListenerReference = _.debounce(
      () => {
        const currentViewType = mobileUtils.getViewType();
        if (self.props.viewType === currentViewType) {
          return;
        }

        self.props.updateViewType(currentViewType);
        // Using 10ms for the debounce here to minimize the number of times
        // this function runs, which still making sure that the UI updates quickly
        // in the case of a viewType change. This seems reasonable because the function
        // is non-blocking and a no-op in the case that the viewType doesn't change.
      },
      10,
      { leading: false, trailing: true },
    );

    window.addEventListener('resize', this.eventListenerReference);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.eventListenerReference);
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({ viewType: state.global.viewType });
const mapDispatchToProps = dispatch => bindActionCreators({ updateViewType }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MobileWatcher);
